/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountCode
 */
export interface AccountCode {
    /**
     * 
     * @type {string}
     * @memberof AccountCode
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccountCode
     */
    code?: string | null;
}

export function AccountCodeFromJSON(json: any): AccountCode {
    return AccountCodeFromJSONTyped(json, false);
}

export function AccountCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountCode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'code': !exists(json, 'code') ? undefined : json['code'],
    };
}

export function AccountCodeToJSON(value?: AccountCode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currency': value.currency,
        'code': value.code,
    };
}


